import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authHeader } from '@H';
import { confirmAlert } from 'react-confirm-alert';
import BankAccountList from './BankAccountList';

const BankAccountType = () => {
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const editRef = useRef(null);
  const [accountData, setAccountData] = useState({
    account_type: '',
    updated: false,
    editMode: false,
  });

  const handleChange = (e) => {
    setAccountData({
      ...accountData,
      [e.target.name]: e.target.value,
    });
  };

  const cancelEdit = () => {
    setAccountData({
      account_type: '',
      updated: accountData.updated,
      editMode: false,
    });
  };

  const handleEditMode = (account) => {
    setAccountData({
      uuid: account.uuid,
      account_type: account.account_type,
      updated: accountData.updated,
      editMode: true,
    });

    window.scrollTo({
      behavior: 'smooth',
      top: editRef.current.offsetTop - 150,
    });
  };

  const confirmSubmit = (e) => {
    const { account_type } = accountData;
    confirmAlert({
      title: 'Are you sure you want to',
      message: accountData.editMode
        ? `update ${account_type}`
        : 'add a new bank account type',
      buttons: [
        {
          label: 'Yes',
          onClick: () => submitForm(e),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const headers = authHeader(1);
    const url = `${process.env.API_URL}/utils/account-types/`;
    let method = 'POST';
    let formData = accountData;

    if (accountData.editMode) {
      method = 'PUT';
      formData.account_type = accountData.account_type;
    }

    axios({
      method,
      url,
      data: formData,
      headers,
    })
      .then(() => {
        toast.success('Bank account type added successfully');
        window.scrollTo({
          behavior: 'smooth',
          top: editRef.current.offsetTop - 150,
        });
        setIsSubmitting(false);
        setAccountData({
          account_type: '',
          updated: !accountData.updated,
          editMode: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table" ref={editRef}>
        <header>
          <h3>Bank Account Type</h3>
        </header>
        <main>
          <div className="form-content">
            <table>
              <thead>
                <tr>
                  <th>Account type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className={`${accountData.editMode ? 'highlight-bg' : ''}`}>
                  <td>
                    <div className="input-wrapper">
                      <input
                        name="account_type"
                        type="text"
                        onChange={handleChange}
                        placeholder="Account type"
                        value={accountData.account_type}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="form-actions">
              <button className="submit" type="submit" onClick={confirmSubmit}>
                Submit
              </button>
              {accountData.editMode && (
                <button className="red-btn" onClick={cancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </div>
        </main>
      </section>
      <BankAccountList key={accountData.updated} onEdit={handleEditMode} />
    </>
  );
};

export { BankAccountType };
